import { useDeliveryApi } from 'infrastructure/api';
import { ResourceData, useCrudService } from 'framework/crud';
import { cloneDeep } from 'lodash';
import { RisksType } from 'domain/shared/newProject';
import { resolveRiskValidation, risksValidation } from './risksValidation';

const useRiskService = () => {
  const singleResourceUrl = '/projects/:id';
  const {
    search: baseSearch,
    update: initialUpdate,
    ...baseCrudRequests
  } = useCrudService({
    singleResourceUrl,
    listResourceUrl: '/projects',
    useService: useDeliveryApi,
  });

  const { sendPostRequest, sendPutRequest, sendPatchRequest, sendDeleteRequest } = useDeliveryApi();

  const risksSearch = async (id: string, request: ResourceData) => {
    const searchParams = cloneDeep(request);
    const response = await sendPostRequest(`/projects/${id}/risks/search`, searchParams);
    return response.json();
  };

  const createRisk = async (id: string, data: RisksType): Promise<RisksType> => {
    const res = await sendPostRequest(`/projects/${id}/risks`, data);
    return res.json();
  };

  const updateRisk = async (id: string, data: RisksType): Promise<RisksType> => {
    const res = await sendPutRequest(`/projects/risks/${id}`, data);
    return res.json();
  };

  const deleteRisk = async (id: string): Promise<object> => {
    return await sendDeleteRequest(`/projects/risks/${id}`);
  };

  const resolveRisk = async (riskId: string, data: object): Promise<object> => {
    const response = await sendPutRequest(`/projects/risks/${riskId}/resolve`, data);
    return response.json();
  };

  const escalateRisk = async (riskId: string, data: object): Promise<object> => {
    const response = await sendPatchRequest(`/projects/risks/${riskId}/escalate`, data);
    return response.json();
  };

  const deescalateRisk = async (riskId: string, data: object): Promise<object> => {
    const response = await sendPatchRequest(`/projects/risks/${riskId}/de-escalate`, data);
    return response.json();
  };

  const risksBatch = async (id: string, data: RisksType[]): Promise<RisksType[]> => {
    const res = await sendPostRequest(`/projects/${id}/risks/batch`, { batch: data });
    return res.json();
  };

  const getRisksValidationSchema = () => Promise.resolve(risksValidation);
  const getResolveRiskValidationSchema = () => Promise.resolve(resolveRiskValidation);

  return {
    ...baseCrudRequests,
    createRisk,
    risksSearch,
    risksBatch,
    resolveRisk,
    updateRisk,
    deleteRisk,
    escalateRisk,
    deescalateRisk,
    getRisksValidationSchema,
    getResolveRiskValidationSchema,
  };
};

export default useRiskService;
